export const isFileUnderMaxSize = (file: File, maxSizeMB: number = 3): boolean => {
  const sizeInMB = file.size / (1024 * 1024);

  return sizeInMB <= maxSizeMB;
};
